import gql from 'graphql-tag';

/**
 * Bản rút gọn của `productSearch`, chỉ lấy id — cho trang Brand lấy thứ tự
 * Bán chạy / Mới nhất từ BE mà không tải lại toàn bộ sản phẩm.
 */
export default gql`
  query productSearchIds($sort: [ProductSort!]!, $filter: ProductFilter, $pagination: Pagination!) {
    productSearch(sort: $sort, filter: $filter, pagination: $pagination) {
      data {
        id
      }
    }
  }
`;
